const PERMANENT = 'permanent';
const DETECTION_BASED = 'detection_based';
const EXPERIMENT = 'experiment';

export const CONFUSION_DIALOG_TYPE_ENUM = {
    PERMANENT,
    DETECTION_BASED,
    EXPERIMENT
};

const DETECTION = 'detection';
const HEURESTIC = 'heurestic';

export const CONFUSION_MODEL_TYPE = {
    DETECTION,
    HEURESTIC
};

const SHAKE_CONTEXT_HELP = 'shakeContextHelp';
const SHOW_CONFUSION_DIALOG = 'showConfusionDialog';

export const CONFUSION_REACTION_TYPE = {
    SHAKE_CONTEXT_HELP,
    SHOW_CONFUSION_DIALOG
};

const TIMEOUT_PROPAGATION = 'timeoutPropagation';
const GUIDE_INTERACTION_PROPAGATION = 'guideInteractionPropagation';

/**
 * @type {ConfusionPropagationTypeEnum}
 */
export const CONFUSION_PROPAGATION_TYPE_ENUM = {
    TIMEOUT_PROPAGATION,
    GUIDE_INTERACTION_PROPAGATION
};
